import { render, staticRenderFns } from "./start.vue?vue&type=template&id=78441eef&scoped=true&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"
import style0 from "./start.vue?vue&type=style&index=0&id=78441eef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78441eef",
  null
  
)

export default component.exports